// extracted by mini-css-extract-plugin
module.exports = {"link":"style-module--link--1t8Xs","linkActive":"style-module--linkActive--1LVRn"};